"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Saves course called event to history. If the same course is called again,
 * updates the timestamp instead of creating a duplicate entry.
 * @param event of type CourseCalledEvent
 * @param prevState previous order
 */
function default_1(event, prevState = {}) {
    return {
        ...prevState,
        courseCalls: [
            ...(prevState.courseCalls || []),
            {
                courseName: event.courseName,
                courseId: event.courseId,
                calledAt: event.timestamp,
                calledBy: event.triggeredBy,
                isPrinted: false,
                items: [],
            },
        ].sort((a, b) => b.calledAt - a.calledAt),
    };
}
exports.default = default_1;
//# sourceMappingURL=orderCourseCalled.js.map